export default "__VITE_ASSET__ByFydl$4__"